/**
 * Represents actions that client could perform in response to handling an `streamTimelineEvent`
 */

export enum Action {
  // Represents no action
  NONE = 'none',

  // Represents suggested action is stop playback.
  STOP_PLAYBACK = 'stopPlayback',

  // Represents suggested action is start playback.
  START_PLAYBACK = 'startPlayback',

  // Represents
  DISPLAY = 'display',

  HIDE = 'HIDE',
}
